/* eslint-disable no-console */
import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player, CallupHead, SimpleGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import { h5PageCount } from 'ThreeTerminal_utils';
// import { cookie } from '@ifeng-fe/ui_base';
import VideoTitle from './videoTitle';
import CollectTitle from './collectTitle';
import BeforeVideo from './beforeVideo';
import AfterVideo from './afterVideo';
import ReadNum from './readNum';
import styles from './index.css';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng-fe/callapp';
import NoSSR from 'react-no-ssr';
import md5 from 'md5';
import { getUaParser } from '../../../../services/api';

if (typeof window === 'object' && !window.IntersectionObserver) {
    require('../../../../utils/interSectionObserverPolyfill');
}

class VideoArea extends PureComponent {
    static propTypes = {
        contentData: PropTypes.object,
        uid: PropTypes.string,
        // eslint-disable-next-line react/no-unused-prop-types
        whiteListModeShow: PropTypes.bool,
        slideConfig: PropTypes.object,
        wxLaunch: PropTypes.object,
        isHitBlack: PropTypes.bool,
        sourceAlias: PropTypes.string,
        sourceReason: PropTypes.string,
        wemediaEAccountId: PropTypes.string,
        videoShareUnfold: PropTypes.string,
    };

    constructor(props) {
        super(props);

        // this.firstClick = true;

        this.videoApis = null;

        // const ua = navigator.userAgent;

        // this.isAndroid = ua.match(/android/gi);

        // this.isIos = ua.match(/iphone|ipod|ipad/gi);

        this.state = {
            showAndroidAlert: false,
            // 截流视频白名单默认全部关闭状态
            whiteListModeShow: false,
            crowdid: typeof window === 'undefined' ? '' : this.getUrlParams(location.href).crowdid,
            isVideoPlayerEnd: false,
            isPlay: false,
        };
    }

    getUrlParams = (url) => {
        const result = {};
        const search = url.split('?')[1] || '';
        const params = search.split('&');
        let param = [];

        for (let i = 0, iLen = params.length; i < iLen; i++) {
            param = params[i].split('=');
            if (param.length === 2) {
                result[param[0]] = decodeURIComponent(param[1]);
            }
        }

        return result;
    };

    handleCallApp = (isJumpQQlink) => {
        const {
            contentData: {
                videoInfo: { guid },
                isVideoShare,
                docData: { base62Id }
            },
            uid,
            videoShareUnfold,
        } = this.props;
        let downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';
        let guideKind = '';

        if (videoShareUnfold === '2') {
            guideKind = 'inter_ymdl03';
            downloads = {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7226560523349536768',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9140',
            };
        }

        if (videoShareUnfold === '3') {
            guideKind = 'inter_ymdl04';
            downloads = {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7226560680115843072',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9141',
            };
        }

        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${base62Id}`
        };

        callApp({
            client,
            docType: 'phvideo',
            pid: guid,
            userId: uid,
            kind: guideKind || 'inter_fxy04',
            noKindFrom: 1,
            download: downloads.download,
            downloadAd: downloads.downloadAd,
            isCopySchemeUrl: isJumpQQlink,
            ...callImmersiveVideoConfig
        });
    };

    handleUnFoldCallUp = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const {
            contentData: {
                videoInfo: { guid },
            },
            videoShareUnfold,
        } = this.props;
        let showbarAction = 'playvideo';

        if (videoShareUnfold === '2') {
            showbarAction = 'playvideo1';
        }

        if (videoShareUnfold === '3') {
            showbarAction = 'playvideo2';
        }

        h5PageCount([
            {
                behavior: 'action',
                type: showbarAction,
                other: {
                    ref: guid,
                    kind: 'video',
                },
            },
        ]);

        if (isCallApp) {
            this.handleCallApp(isJumpQQlink);
        }
    };

    closeAlertBox = () => {
        const {
            contentData: {
                unfoldType,
                videoInfo: { guid },
            },
            videoShareUnfold,
        } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'cancelentry',
                other: {
                    ref: guid,
                    kind: 'video',
                },
            },
        ]);

        this.setState({
            showAndroidAlert: false,
        });

        if (videoShareUnfold !== '3') {
            this.videoApis.play();
        }
    };

    handleUnflod = () => {
        const {
            contentData: {
                docData: { base62Id },
                unfoldType,
                unfoldType: { stopReadArticle },
                isVideoShare,
            },
            videoShareUnfold,
        } = this.props;

        if (!isVideoShare) {
            if (stopReadArticle && stopReadArticle.filter((i) => i.id === base62Id).length) {
                this.handleUnFoldCallUp();
            } else if (videoShareUnfold === '3') {
                this.setState({
                    showAndroidAlert: true,
                });
            }
        }
    };

    handleVideoPlay = () => {
        const {
            contentData: {
                docData: { base62Id },
                unfoldType,
                unfoldType: { stopReadArticle },
                isVideoShare,
            },
            videoShareUnfold,
        } = this.props;

        if (!videoShareUnfold || videoShareUnfold === '1') {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'playvideo',
                    other: {
                        ref: document.referrer,
                        kind: 'video',
                        url: location.href,
                    },
                },
            ]);
        }

        if (unfoldType && !isVideoShare) {
            if (stopReadArticle && stopReadArticle.filter((i) => i.id === base62Id).length) {
                this.handleUnFoldCallUp();
            } else if (videoShareUnfold === '1') {
                this.videoApis.play();
                this.setState({
                    isPlay: true,
                });

                return false;
            } else if (videoShareUnfold === '2') {
                this.setState({
                    showAndroidAlert: true,
                });

                return false;
            }
        } else {
            this.videoApis.play();
            this.setState({
                isPlay: true,
            });

            return false;
        }
    };

    componentDidMount() {
        this.handleBrowserUA();
    }

    // 获取H5端运行视频浏览器的 UA
    handleBrowserUA = async () => {
        const {
            contentData: { whiteVideoData },
        } = this.props;

        // {iOS: Array(1), Android: Array(1)}
        const structuredVideoData = new Object(whiteVideoData);
        const { iOS, Android } = structuredVideoData;

        const u = navigator.userAgent;

        const uaHash = md5(u);

        const uaParserData = await getUaParser(uaHash);

        // 从接口中获取手机操作系统名称
        const uaParserOsName = uaParserData.os.name;
        const uaParserBrowserName = uaParserData.browser.name;

        if (uaParserOsName === 'Android' && Android.length !== 0) {
            // 安卓白名单中能正常播放的浏览器名称
            if (Android.indexOf(uaParserBrowserName) > -1) {
                this.setState({
                    whiteListModeShow: true,
                });
            }
        } else if (uaParserOsName === 'iOS' && iOS.length !== 0) {
            // eslint-disable-next-line no-empty
            if (iOS.indexOf(uaParserBrowserName) > -1) {
            } else {
                this.setState({
                    whiteListModeShow: true,
                });
            }
            // eslint-disable-next-line no-empty
        } else if (uaParserOsName === 'Mac OS') {
            // Mac OS端打开 默认正常截流播放
            this.setState({
                whiteListModeShow: true,
            });
        } else if (uaParserData === undefined) {
            // 接口挂掉，视频全部正常播放
            this.setState({
                whiteListModeShow: true,
            });
        }

        // console.log('uaParserData', uaParserData);
    };

    beforeVideoPlayedHandle = () => {
        this.videoApis.play();
    };

    getSchemeLinkGuide = () => {
        const {
            videoShareUnfold,
            contentData: { 
                _id,
                docData: { base62Id },
             },
            wxLaunch,
        } = this.props;

        let guideKind = 'share01';

        if (videoShareUnfold === '2') {
            guideKind = 'inter_ymdl03';
        }

        if (videoShareUnfold === '3') {
            guideKind = 'inter_ymdl04';
        }
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${base62Id}`,
        };

        const schemeLinkGuide =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'phvideo',
                      pid: _id,
                      ...callImmersiveVideoConfig
                  })
                : getSchemeLink({
                      docType: 'phvideo',
                      pid: _id,
                      kind: guideKind,
                      noKindFrom: 1,
                      ...callImmersiveVideoConfig
                  });

        return schemeLinkGuide;
    };

    sendExpHandle = () => {
        const { videoShareUnfold } = this.props;

        if (!videoShareUnfold || videoShareUnfold === '1') return;

        let actionType = 'playvideo';

        if (videoShareUnfold === '2') {
            actionType = 'playvideoExp1';
        }
        if (videoShareUnfold === '3') {
            actionType = 'playvideoExp2';
        }

        h5PageCount([
            {
                behavior: 'action',
                type: actionType,
                other: {
                    ref: document.referrer,
                    kind: 'video',
                    url: location.href,
                },
            },
        ]);
    };

    render() {
        const {
            contentData: {
                videoInfo,
                videoInfo: { guid, title },
                docData: { url, base62Id, subscribe, type, videoType, miniVideoPoster, summary, cardSummary },
                headKeyword,
                shareMediaIdApp,
                unfoldType: { videoShareUnfoldLayer = {} } = {},
                isVideoShare,
                _id,
                docData,
                beforeVideoData,
                searchPath,
                classV,
                hasCopyRight,
                readNumConfig,
            },
            uid,
            slideConfig,
            wxLaunch,
            isHitBlack,
            contentData,
            sourceAlias,
            sourceReason,
            wemediaEAccountId,
            videoShareUnfold,
        } = this.props;
        const { crowdid, isVideoPlayerEnd, isPlay } = this.state;

        // 如果小视频有自己的封面，则用自己的miniVideoPoster，没有，正常使用bigPosterUrl
        if (videoType && videoType === 'miniVideo' && miniVideoPoster !== '') {
            videoInfo.bigPosterUrl = miniVideoPoster;
        }
        videoInfo.summary = summary;
        videoInfo.cardSummary = cardSummary;

        // 视频截流时间
        const { showAndroidAlert } = this.state;

        const callImmersiveVideoConfig1 = crowdid ? {} : {
            type: 'videoimmersionv2',
            id: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${base62Id}`
        };

        const headData = {
            isVideoShare,
            pageInfo: {
                type: crowdid ? 'videoSeries' : 'phvideo',
                url,
                id: _id,
                crowdid,
                base62Id: crowdid ? base62Id : '',
                downloads: isVideoShare
                    ? {}
                    : {
                          download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                          downloadAd:
                              'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
                      },
                ...callImmersiveVideoConfig1
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: guid,
                kind: 'phvideo',
                callupKind: 'share52201',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: guid,
                kind: 'phvideo',
                callupKind: 'share52201',
            },
            hotKeyword: headKeyword,
            other: shareMediaIdApp ? { subid: shareMediaIdApp } : {},
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
        };

        // console.log(headData, '33333333333');

        const videoConfig = {
            height: '100%',
            hasMargin: false,
            showTitle: false,
            showPoster: true,
            showController: true,
            // m3u8Play: !location.search.includes('isPreview=1'),
            beforePlayCB: (exposeApis) => {
                this.videoApis = exposeApis;

                // console.log(this.videoApis, '1111111');
                this.handleVideoPlay();
            },
            cutOffPlay: videoShareUnfold === '3' && !isVideoShare, // 是否断流
            // 每次点击播放区域回调
            eachTimeClickPlayer: () => {
                this.handleUnflod();
            },
            getExposeApisCb: (apis) => {
                this.videoApis = apis;
            },
            videoPlayerEndCb: () => {
                this.setState({
                    isVideoPlayerEnd: true,
                });
            },
            showFullScreenBtn: !(
                docData.guideAppSetting &&
                docData.guideAppSetting.duration &&
                docData.guideAppSetting.enable
            ),
        };
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725215087',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7640',
              };
        const wxLaunchType = wxLaunch.wxLaunchType;
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const callImmersiveVideoConfig2 = crowdid ? {} : {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${base62Id}`
        };
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'phvideo',
                      pid: _id,
                      ...callImmersiveVideoConfig2
                  })
                : getSchemeLink({
                      docType: 'phvideo',
                      pid: _id,
                      kind: 'share01',
                      ...callImmersiveVideoConfig2
                  });
        const schemeLinkGuide = this.getSchemeLinkGuide();
        const newVideoInfo = {
            ...videoInfo,
            callAppConfig: {
                client: 'newsApp',
                docType: 'phvideo',
                pid: _id,
                kind: 'inter_ycjlnr01',
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1471376074272',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8817',
                ...callImmersiveVideoConfig2
            },
            isWhiteListModeShow: this.state.whiteListModeShow,
            videoType,
            videoWxLanch: {
                schemeLink,
                wxLaunchType,
                wxLaunchSwitch,
                isVideoShare,
            },
        };
        // 按时长进行判断。小于60秒不要所有贴片。小于300秒改为后贴片。五分钟以上，仍为前贴。
        const videoDuration = videoInfo.duration || 0;
        const hasBeforeVideo = videoDuration >= beforeVideoData.beforeVideoTime;
        const hasAfterVideo =
            videoDuration >= beforeVideoData.afterVideoTime && videoDuration < beforeVideoData.beforeVideoTime;
        const beforeVideoConfig = {
            duration: (beforeVideoData.videoTime && parseInt(beforeVideoData.videoTime)) || 0,
            playUrl: beforeVideoData.videoUrl,
            postUrl: videoInfo.bigPosterUrl,
            beforeVideoChannel: beforeVideoData.beforeVideoChannel,
            isOpen: beforeVideoData.isOpen,
            beforeVideoScheme: beforeVideoData.beforeVideoScheme,
            isVideoShare,
            wxLaunchSwitch,
            wxLaunchType,
            searchPath,
            classV,
        };

        const afterVideoConfig = {
            duration: (beforeVideoData.videoTime && parseInt(beforeVideoData.videoTime)) || 0,
            playUrl: beforeVideoData.videoUrl,
            postUrl: videoInfo.bigPosterUrl,
            beforeVideoChannel: beforeVideoData.beforeVideoChannel,
            isOpen: beforeVideoData.isOpen,
            isVideoShare,
            wxLaunchSwitch,
            wxLaunchType,
            searchPath,
            classV,
            isVideoPlayerEnd,
        };
        const readNumConfigData = {
            ...readNumConfig,
            hasCopyRight,
            base62Id,
            createTime: contentData?.docData?.publishedTime || '',
            searchPath,
            wemediaEAccountId,
            guid,
        };

        return (
            <Fragment>
                <NoSSR>
                    <CallupHead content={headData} />
                </NoSSR>
                <NoSSR>
                    <div className={styles.videoArea}>
                        <div
                            style={
                                videoType === 'miniVideo'
                                    ? { paddingTop: '100%', position: 'relative' }
                                    : { paddingTop: '56%', position: 'relative' }
                            }>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    left: '0px',
                                    right: '0px',
                                    bottom: '0px',
                                    width: '100%',
                                    height: '100%',
                                }}
                                onClick={this.sendExpHandle}>
                                <Chip id="170111" type="struct" title="点击视频是否断流" groupName="点击视频是否断流">
                                    <Player videoConfig={{ ...newVideoInfo }} playermsg={videoConfig} />
                                </Chip>
                                {!isHitBlack && hasBeforeVideo && (
                                    <BeforeVideo
                                        content={beforeVideoConfig}
                                        beforeVideoPlayedHandle={this.beforeVideoPlayedHandle}
                                    />
                                )}
                                {!isHitBlack && hasAfterVideo && isVideoPlayerEnd && (
                                    <AfterVideo content={afterVideoConfig} />
                                )}
                                {!isPlay && <ReadNum content={readNumConfigData} />}
                            </div>
                        </div>
                    </div>
                </NoSSR>
                {!crowdid && (
                    <>
                        <VideoTitle
                            content={videoInfo}
                            isVideoShare={isVideoShare}
                            wemediaDetail={subscribe}
                            id={guid}
                            _id={_id}
                            userId={uid}
                            wxLaunch={wxLaunch}
                            sourceAlias={sourceAlias}
                            sourceReason={sourceReason}
                            wemediaEAccountId={wemediaEAccountId}
                        />
                    </>
                )}
                {crowdid && (
                    <CollectTitle
                        crowdid={crowdid}
                        base62Id={base62Id}
                        wxLaunch={wxLaunch}
                        encodeId={_id}
                        isVideoShare={isVideoShare}
                    />
                )}
                <SimpleGuideLayer
                    isShowGuideLayer={showAndroidAlert}
                    unfoldType={videoShareUnfold}
                    unfoldTextInfo={videoShareUnfoldLayer}
                    closeGuideFn={this.closeAlertBox}
                    gotoClientFn={this.handleUnFoldCallUp}
                    wxLaunchType={wxLaunch.wxLaunchType}
                    wxLaunchSwitch={wxLaunch.wxLaunchSwitch}
                    schemeLink={schemeLinkGuide}
                />
            </Fragment>
        );
    }
}

export default errorBoundary(VideoArea);
